import { Component, OnInit } from '@angular/core'
import { TabComponent } from '../tab/tab.component'
import { RushMainService } from '@rush-shared/services/rush-main.service'
import { RushComponent } from '../rush-content/rush/rush.component'
import { ClassicComponent } from '../rush-content/classic/classic.component'
import { CommonModule } from '@angular/common'
import { TabsConst } from '@rush-shared/constants'
import { TabModel } from '@rush-shared/models'
import { TabNamesEnums } from '@rush-shared/enums'

@Component({
  selector: 'app-rush-tabs',
  standalone: true,
  imports: [
    TabComponent,
    RushComponent,
    ClassicComponent,
    CommonModule,
  ],
  templateUrl: './rush-tabs.component.html',
  styleUrl: './rush-tabs.component.sass',
})
export class RushTabsComponent implements OnInit {
  tabs = TabsConst
  activeTab: TabModel
  tabNamesEnums = TabNamesEnums

  constructor(private _rushMainService: RushMainService) {}

  ngOnInit(): void {
    this._rushMainService.activeTab$.observer.subscribe((activeTab) => (this.activeTab = activeTab))
  }
}
